import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useAuth } from "../loginpage/AuthContext";

// Lazy loaded pages
const LoginPage = lazy(() => import("../loginpage"));
const MainLayout = lazy(() => import("../components/MainLayout"));
const CustomerPage = lazy(() => import("../settingssidebar/customer"));
const SubscriptionPage = lazy(() => import("../settingssidebar/subscription"));
const BillingPage = lazy(() => import("../settingssidebar/billing"));
const UserPage = lazy(() => import("../settingssidebar/user"));
const GlobalSync = lazy(() => import("../settingssidebar/globalSync"));
const ProfilePage = lazy(() => import("../settingssidebar/profile"));
const TeamPage = lazy(() => import("../settingssidebar/Role"));
const FileData = lazy(() => import("../settingssidebar/files"));
const MapperUpload = lazy(() => import("../settingssidebar/mapper upload"));
const IntegratorHistory = lazy(() => import("../settingssidebar/integrator history"));
const Email = lazy(() => import("../settingssidebar/email"));
const Instance = lazy(() => import("../settingssidebar/instance"));
const ObjectMapper = lazy(() => import("../settingssidebar/object mapper"));
const ExportPage = lazy(() => import("../settingssidebar/export"));

const AppRoutes = () => {
  const { authUser, isInitialized } = useAuth();
  const isAuthenticated = !!authUser?.token;

  // Show loading while authentication is being initialized
  if (!isInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  const ProtectedRoute = () => {
    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
  };

  return (
    <Router>
      {/* <Suspense fallback={<div>Loading...</div>}> */}
        <Routes>
          {/* Always show login page at root, regardless of auth state */}
          <Route path="/" element={<LoginPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/customer" element={<CustomerPage />} />
              <Route path="/subscription" element={<SubscriptionPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/user" element={<UserPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/files" element={<FileData />} />
              <Route path="/mapper-upload" element={<MapperUpload />} />
              <Route path="/integrator-history" element={<IntegratorHistory />} />
              <Route path="/email" element={<Email />} />
              <Route path="/instance" element={<Instance />} />
              <Route path="/object-mapper" element={<ObjectMapper />} />
              <Route path="/globalSync" element={<GlobalSync />} />
              <Route path="/export-data" element={<ExportPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      {/* </Suspense> */}
    </Router>
  );
};

export default AppRoutes;
